import React from 'react'

import styles from './FilterWrapper.module.css'

type FilterWrapperProps = {
  children: React.ReactNode
}

const FilterWrapper = ({ children }: FilterWrapperProps): JSX.Element => (
  <div className={styles.filter}>{children}</div>
)

export default FilterWrapper
